/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBicycle = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12.246 6.566 14.535 10H19v2l-2.001-.001 1.528 2.035a4 4 0 0 1 3.468 3.766L22 18a4 4 0 1 1-5.712-3.616L14.5 11.999 13.465 12l-1.711-2.565-2.329 1.746 4.037 5.046-3.501 2.335a4 4 0 1 1-.31-2.199l.886-.591-3.962-4.953zM6 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm12 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM17 2a3 3 0 1 1-.001 6.001A3 3 0 0 1 17 2zm0 2a1 1 0 1 0 .001 2.001A1 1 0 0 0 17 4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBicycle as Bicycle };
